import React, { useState } from 'react';
import { Menu, MenuItem, Avatar, Box, Divider } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { LoadingButton } from '@mui/lab';

import { useAuth } from '../../../context/AuthContext';
import ModalPreferences from '../../ModalPreferences';

function UserMenu({ anchorEl, handleMenuOpen, handleMenuClose }) {
    /* VARIABLE DECELERATION
    -------------------------------------------------------------------------------------*/
    const { activeUser, logout } = useAuth();
    const [loading, setLoading] = useState(false);
    const [preferencesOpen, setPreferencesOpen] = useState(false);

    /* EVENT LISTENERS
    -------------------------------------------------------------------------------------*/
    const logoutClickHandler = () => {
        setLoading(true);
        logout();
    };

    /* ASYNC FUNCTIONS
    -------------------------------------------------------------------------------------*/

    /* EVENT FUNCTIONS
    -------------------------------------------------------------------------------------*/

    /* RENDER APP
    -------------------------------------------------------------------------------------*/

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={handleMenuOpen}
                onClose={handleMenuClose}
                sx={{ '& .MuiMenu-list': { p: '0px' } }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem
                    sx={{ py: '12px', minWidth: '210px', alignItems: 'center' }}
                    onClick={() => {
                        handleMenuClose();
                    }}
                >
                    <Avatar
                        sx={{ bgcolor: deepOrange[100], color: '#85000b' }}
                        alt={activeUser?.name}
                    >
                        {(activeUser?.name || 'U').charAt(0).toUpperCase()}
                    </Avatar>
                    <Box sx={{ pl: '10px' }}>
                        <Box
                            sx={{
                                fontSize: '15px',
                                fontWeight: '500',
                                textTransform: 'capitalize',
                                lineHeight: '1',
                            }}
                        >
                            {activeUser?.name}
                        </Box>
                        <Box sx={{ fontSize: '12px', color: 'text.secondary' }}>
                            {activeUser?.role}
                        </Box>
                    </Box>
                </MenuItem>

                <Divider sx={{ mt: '0 !important' }} />
                <MenuItem
                    sx={{ py: '8px' }}
                    onClick={() => {
                        handleMenuClose();
                        setPreferencesOpen(true);
                    }}
                >
                    Preferences
                </MenuItem>
                <MenuItem
                    disableRipple
                    sx={{
                        py: '8px',
                        mb: '8px',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0)' },
                    }}
                >
                    <LoadingButton
                        loading={loading}
                        disabled={false}
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            logoutClickHandler();
                        }}
                    >
                        Log Out
                    </LoadingButton>
                </MenuItem>
            </Menu>
            <ModalPreferences
                openModal={preferencesOpen}
                closeModal={() => setPreferencesOpen(false)}
            />
        </>
    );
}

export default UserMenu;
